import { createContext, useContext } from "react";
import type { Branding } from "../api";

/**
 * L'identité livrée, celle de Liwe Services. Elle sert tant que celle du
 * serveur n'est pas arrivée, et si elle ne peut pas l'être : la page ne doit
 * jamais s'afficher sans nom.
 */
export const DEFAULT_BRANDING: Branding = {
  esn_name: "Liwe Services",
  product_short: "LDE",
  product_name: "Liwe Delivery Engine",
  accent_color: "#1b4a8f",
  mail_signature: "L'équipe Liwe Services",
  logo_url: null,
};

export type BrandingState = {
  branding: Branding;
  /** Relit l'identité, après un réglage depuis l'espace ESN. */
  reload: () => void;
};

export const BrandingContext = createContext<BrandingState>({ branding: DEFAULT_BRANDING, reload: () => {} });

/** L'identité de l'instance (marque blanche). */
export function useBranding(): Branding {
  return useContext(BrandingContext).branding;
}

/** Relit l'identité. */
export function useReloadBranding(): () => void {
  return useContext(BrandingContext).reload;
}

/**
 * « de » devant un nom, élidé devant une voyelle : « de Liwe Services »,
 * « d'Acme Conseil ». Le h n'est pas élidé : aspiré ou muet, il ne se devine
 * pas.
 */
export function deNom(nom: string): string {
  return /^[aeiouyàâäéèêëîïôöûüù]/i.test(nom.trim()) ? `d'${nom}` : `de ${nom}`;
}
